import React from 'react';
import './AuthHeader.css';

export function AuthHeader({ activeTab }) {
  return (
    <div className="auth-header">
      <div className="auth-header__logo-wrapper">
        <img
          src="/images/aimers_logo.jpg"
          alt="AIMERS 로고"
          className="auth-header__logo-img"
        />
      </div>
      <h1 className="auth-header__title">
        {activeTab === 'login' ? 'AIMERS 로그인' : 'AIMERS 회원가입'}
      </h1>
      <p className="auth-header__subtitle">
        {activeTab === 'login'
          ? '스마트 양궁 기록과 훈련 통계를 확인하세요'
          : '모든 궁사를 위한 데이터 기반 훈련을 시작하세요'}
      </p>
    </div>
  );
}
